
// PictureScroller.js 로부터진입

import React, { useState, useEffect } from 'react';
import PictureLabel from './PictureLabel4';
// import PictureLabel4 from './PictureLabel3_std';
import PictureLabel2 from './PictureLabel2';
import PictureLabel_odd from './PictureLabel_odd';

import PictureLabel3 from './PictureLabel3';
// import PictureLabel3 from './PictureLabel3_std';

export default props => {
    console.log("props.me: ",props.me);
    if (!props.me) return <></>;

    const [dLabel, setLabel] = useState('none');

    React.useEffect(() => {
        setLabel('none');
        return () => { ; };
    }, [props.me.attachable_id]); // 상세화면이 바뀌면 게시물아이디가 바뀌고 라벨켜고끄는거도 끄는걸로 초기화한다.


const jsx=<div className="PictureGround">
<style jsx>{`
.picture{
    position: relative;
}

.picture img{
    width: 100%;
}

.label-board{
    position: relative;
    top: 0;
    left: 0;
}

.toggler{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    /* box-shadow: grey 10px 10px 20px; */
}

.picture-ground{
    margin-bottom: 15px;
}


`}</style>
<div className="picture-ground">
    <div className="picture label-board">
        
            <div className="toggler" 
                style={{ display: (props.me.pins && props.me.pins.length > 0 ? 'block' : 'none') }} 
                onClick={() => { dLabel == 'none' ? setLabel('block') : setLabel('none') }}
            >
                <a><img src={dLabel == 'none' ? 
                // "/assets/images0416/group-3@3x.png"
                "/assets/images/KakaoTalk_20200521_182550257.png"
                : "/assets/images2/btn-brand@3x.png"} /></a>
            </div>
        <img src={props.me.optimized_url} />
            {props.me.pins && props.me.pins.filter((v) => v.brand)
            .map((v, i) =>
            <div key={i} className="grid-item">
                <PictureLabel d={dLabel} x={v.left / props.me.width * 100} y={v.top /props.me.height *100} me={v} />
            </div>
        )}
        {/* <PictureLabel2 d={dLabel} x={100} y={10} trademark="WKOREA" url="http://wkorea.com/" />
        <PictureLabel3 d={dLabel} x={80} y={20} trademark="NNN" url="http://naver.com/" />
        <PictureLabel_odd d={dLabel} x={82} y={30} trademark="NOBRAND" /> */}

    </div>
</div>

</div>;

return(jsx);
}